import React, { useState, useRef } from "react";
export default function HeroSection() {
  const [isMuted, setIsMuted] = useState(true);
  const videoRef = useRef(null);
  const toggleSound = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };
  return <section id="hero-section"
  // Changed height to be much bigger: min-h-[750px] and 80vh
  className="relative w-full min-h-[750px] h-[80vh] flex items-center justify-center overflow-hidden bg-zinc-950">
      
      {/* Վիդեո ֆոն (Video Background) */}
      <video ref={videoRef} autoPlay loop muted={isMuted} // Controlled by our state now
    playsInline src="https://summary-monarch.10web.cloud/wp-content/uploads/2026/05/Armsat_launch_video.mp4" className="absolute inset-0 w-full h-full object-cover z-0" />
      
      {/* Մգեցնող շերտ (Dark Overlay) */}
      {/* CHANGED: Replaced bg-black/60 with bg-black/20 to make the video much brighter */}
      <div className="absolute inset-0 bg-black/20 z-10"></div>
      
      {/* Տեքստ (Text) */}
      <div className="relative z-20 text-center px-4 w-full max-w-5xl mx-auto">
        
      </div>

      {/* Ձայնի կոճակ (Sound Toggle Button) */}
      <button onClick={toggleSound} aria-label={isMuted ? "Unmute video" : "Mute video"} className="absolute bottom-8 right-8 z-30 flex items-center justify-center w-14 h-14 bg-white/10 hover:bg-white/25 backdrop-blur-md border border-white/20 rounded-full text-white transition-all duration-300">
        {isMuted ?
      // Muted Icon
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M11 5L6 9H2v6h4l5 4V5z" />
            <line x1="23" y1="9" x2="17" y2="15" />
            <line x1="17" y1="9" x2="23" y2="15" />
          </svg> :
      // Sound On Icon
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M11 5L6 9H2v6h4l5 4V5z" />
            <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
            <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
          </svg>}
      </button>
      
    </section>;
}